import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  Optional,
  ViewChild,
} from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import { HttpClient, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-energy-providers-modal',
  templateUrl: './energy-providers-modal.component.html',
  styleUrls: ['./energy-providers-modal.component.css'],
})
export class EnergyProvidersModalComponent implements OnInit {
  @ViewChild('UploadFileInput', { static: false }) uploadFileInput: ElementRef;
  // managerMaintenanceForm: FormGroup;
  // fileInputLabel: string;
  managerMaintenanceForm = this.fb.group({
    promoCode: [, Validators.required],
    uploadedImage: [, Validators.required],
    providerEmail: [, Validators.required],
    providerName: [, Validators.required],
    providerOperationHours: [, Validators.required],
    providerPhone: [, Validators.required],
    provider_duns: [, Validators.required],
    recipientEmail: [, Validators.required],
    status: [, Validators.required],
    utilityContact: [, Validators.required],
    utilityName: [, Validators.required],
  });
  fromPage: any;
  fromDialog: string;
  action: any;
  itemData: any;
  providersStatus: [
    {
      Status: 'Active';
    },
    {
      Status: 'Inctive';
    }
  ];
  selectedFileName: File = null;
  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private residentialService: ResidentialService, // public dialogRef: MatDialogRef<EnergyProvidersModalComponent>, // @Inject(MAT_DIALOG_DATA) public data: DialogData,

    public dialogRef: MatDialogRef<EnergyProvidersModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.fromPage = data.pageValue;
    this.action = data.action;
    this.itemData = data.itemData;
  }

  ngOnInit() {
    console.log('parent', this.fromPage);
    if (this.action == 'Update') {
      const postobj = this.setModulesInfo();
      this.managerMaintenanceForm.patchValue({
        // {ModuleID: "1", ModuleName: "ACH Credit FY"}
        promoCode: this.itemData['PromoCode'],
        uploadedImage: this.itemData['ProviderCloudLogo'],
        providerEmail: this.itemData['ProviderEmail'],
        providerName: this.itemData['ProviderName'],
        providerOperationHours: this.itemData['ProviderOperationHours'],
        providerPhone: this.itemData['ProviderPhone'],
        recipientEmail: this.itemData['RecipientEmail'],
        status: this.itemData['Status'],
        utilityContact: this.itemData['UtilityContact'],
        utilityName: this.itemData['UtilityName'],
      });
    }
  }
  fileSelecte(event) {
    // this.selectedFileName = <File>event.target.files[0];
    // console.log('selected file', this.selectedFileName);
    const file = event.target.files[0];
    // this.fileInputLabel = file.name;
    this.managerMaintenanceForm.get('uploadedImage').setValue(file);
  }
  setModulesInfo() {
    let uploadedImage = this.selectedFileName;
    let promoCode = this.managerMaintenanceForm.get('promoCode').value;
    let providerEmail = this.managerMaintenanceForm.get('providerEmail').value;
    let providerName = this.managerMaintenanceForm.get('providerName').value;
    // let providerOperationHours = this.managerMaintenanceForm.get(
    //   'providerOperationHours'
    // ).value;
    let providerPhone = this.managerMaintenanceForm.get('providerPhone').value;
    let utilityName = this.managerMaintenanceForm.get('utilityName').value;
    let recipientEmail =
      this.managerMaintenanceForm.get('recipientEmail').value;
    let status = this.managerMaintenanceForm.get('status').value;
    let utilityContact =
      this.managerMaintenanceForm.get('utilityContact').value;
    let postobj = {
      PromoCode: promoCode,
      // ProviderAPIURL: string;
      ProviderEmail: providerEmail,
      // ProviderLogo: providerCloudLogo;
      ProviderCloudLogo: uploadedImage,
      ProviderName: providerName,
      // ProviderOperationHours: providerOperationHours,
      ProviderPhone: providerPhone,
      // ProviderURL: string;
      // Provider_duns: string;
      Status: status,
      UtilityContact: utilityContact,
      UtilityName: utilityName,
      // Environment: string;
      RecipientEmail: recipientEmail,
    };
    return postobj;
  }
  postDataOfNewEnergyProvider() {
    const postobj = this.setModulesInfo();
    if (this.action == 'Update') {
      this.updateProvider(postobj);
    } else {
      this.createProvider(postobj);
    }
  }
  createProvider(postobj) {
    const formData = new FormData();
    formData.append(
      'uploadedImage',
      this.managerMaintenanceForm.get('uploadedImage').value
    );
    this.residentialService
      .postDataOfNewEnergyProvider(postobj)
      .subscribe((response: any) => {
        console.log('postreports', response);
        // this.fromPage = [...this.fromPage];
        this.dialogRef.close({ event: this.action, data: this.fromPage });
      });
  }
  updateProvider(postobj) {
    let rowIndex = this.fromPage.findIndex(
      (element) =>
        element['ProviderName'] == this.itemData['ProviderName'] &&
        element['UtilityName'] == this.itemData['UtilityName']
    );
    this.residentialService
      .postDataOfNewEnergyProvider(postobj)
      .subscribe((response: any) => {
        console.log('postreports', response);
        if (rowIndex) {
          this.fromPage[rowIndex] = JSON.parse(JSON.stringify(postobj));
        }
        // this.fromPage = [...this.fromPage];
        this.dialogRef.close({ event: this.action, data: this.fromPage });
      });
  }
  closeDialog(): void {
    this.dialogRef.close();
  }
}
